/*
 * File: base-form-group.ts
 * File Created: 2024-01-11 05:44:29
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:31:26
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../base-form-component";

@Component
export default class BaseFormGroup extends BaseFormComponent {
    /// label helper
    get labelText() {
        return this.label ? `${this.required ? "* " : ""}${this.label}` : "";
    }
}
